import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import RateReviewRoundedIcon from '@mui/icons-material/RateReviewRounded';
import React from 'react';

import { AnnotationWorkingStates } from 'interfaces/annotation';

export const AnnotationWorkingStatesIcons = {
  [AnnotationWorkingStates.Annotating]: <DescriptionRoundedIcon />,
  [AnnotationWorkingStates.QA]: <RateReviewRoundedIcon />,
  [AnnotationWorkingStates.Done]: <CheckCircleRoundedIcon />,
};

export const AnnotationWorkingStateLabels: Record<AnnotationWorkingStates, string> = {
  [AnnotationWorkingStates.Annotating]: 'Annotating',
  [AnnotationWorkingStates.QA]: 'QA',
  [AnnotationWorkingStates.Done]: 'Done',
};

export const getAnnotationWorkingStateLabel = (state: AnnotationWorkingStates) =>
  AnnotationWorkingStateLabels[state] ?? state;
